import { IconCloud } from '../../primitives/icon-cloud';

export function Loader() {
  return (
    <div aria-busy="true" aria-live="assertive" className="grid justify-center overflow-hidden">
      <IconCloud
        icons={[
          <Icons.b key="B" />,
          <Icons.g key="G" />,
          <Icons.m key="M" />,
          <Icons.b key="B2" />,
          <Icons.g key="G2" />,
          <Icons.m key="M2" />,
          <Icons.b key="B3" />,
          <Icons.g key="G3" />,
          <Icons.m key="M3" />,
        ]}
      />
      <p className="mb-24 animate-pulse text-center text-sm text-muted-foreground">Cargando...</p>
    </div>
  );
}

const Icons = {
  g: () => (
    <svg
      width="100"
      height="100"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15" cy="15" r="15" fill="#F9F9F9" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.83 13.7135H14.703V16.6419H20.5924C20.5099 17.0726 20.3597 17.488 20.1471 17.873C19.7153 18.5968 19.0455 19.1535 18.2486 19.4508C17.4691 19.7715 16.489 19.9345 15.3065 19.9709C14.3047 19.9753 13.3106 19.799 12.3733 19.4508C11.576 19.1609 10.9038 18.61 10.4694 17.8903C10.0705 17.1991 9.87111 16.2397 9.87111 15.0121C9.87111 13.7845 10.0699 12.8228 10.4676 12.127C10.9004 11.4037 11.5708 10.8477 12.368 10.5509C13.1457 10.2302 14.1276 10.0672 15.31 10.0308C16.3113 10.0257 17.305 10.202 18.2415 10.5509C18.7915 10.7608 19.2877 11.0876 19.695 11.508H24.0359C23.9317 11.2228 23.8083 10.9447 23.6663 10.6758C23.0329 9.49675 22.0123 8.59052 20.6047 7.95709C19.197 7.32365 17.5594 7.00462 15.6919 7H15.3065C13.4484 7.0289 11.8325 7.32654 10.4588 7.89293C9.01126 8.49169 7.90682 9.36786 7.1455 10.5215C6.38418 11.675 6.00235 13.1719 6 15.0121C6 16.7044 6.31497 18.1406 6.94491 19.3207C7.57484 20.5009 8.59482 21.4089 10.0048 22.0446C11.4125 22.6827 13.0507 23.0011 14.9194 23H15.3065C17.1635 22.9676 18.7788 22.6705 20.1524 22.1088C21.5977 21.5146 22.7021 20.6396 23.4658 19.4837C24.2294 18.3278 24.6112 16.8309 24.6112 14.993C24.6116 14.5669 24.5899 14.1409 24.5462 13.7169L23.83 13.7135Z"
        fill="black"
      />
    </svg>
  ),
  b: () => (
    <svg
      width="100"
      height="100"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15" cy="15" r="15" fill="#F9F9F9" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.7111 14.7032C22.1576 14.8865 22.5724 15.1383 22.9402 15.4495C23.2981 15.77 23.5681 16.1756 23.725 16.6281C23.9128 17.1463 24.0056 17.6938 23.999 18.2445C24.0219 19.0689 23.8211 19.8843 23.4178 20.6053C22.9927 21.2933 22.3462 21.8186 21.5829 22.0961C20.7425 22.432 19.6972 22.6 18.447 22.6H6V7H17.8413C19.3735 7.00582 20.6003 7.32373 21.5215 7.95375C22.4427 8.58377 22.9033 9.56252 22.9033 10.89C22.9116 11.4489 22.8158 12.0046 22.6206 12.5289C22.4316 13.01 22.1156 13.4316 21.7058 13.7495C21.3152 14.0699 20.8443 14.279 20.3433 14.3545C20.8153 14.396 21.2773 14.5138 21.7111 14.7032ZM16.7278 9.403H9.68196L9.69089 13H17.0044C17.75 13 18.2886 12.8518 18.6097 12.5517C18.9308 12.2517 19.0913 11.7942 19.0913 11.1756C19.0948 10.8301 18.9957 10.4919 18.8077 10.2069C18.6237 9.92243 18.3578 9.70584 18.0478 9.58822C17.6215 9.44774 17.1749 9.38507 16.7278 9.403ZM19.5918 19.0785C19.3647 19.3462 19.0686 19.5376 18.7402 19.6292C18.2731 19.7546 17.792 19.8114 17.3104 19.7981H9.68196V16.2H17.3866C18.2405 16.2 18.8752 16.345 19.2906 16.6351C19.7026 16.9251 19.9068 17.3785 19.9068 17.999C19.9292 18.3875 19.8172 18.7713 19.5918 19.0785Z"
        fill="black"
      />
    </svg>
  ),
  m: () => (
    <svg
      width="100"
      height="100"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15" cy="15" r="15" fill="#F9F9F9" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3093 18.8844L20.84 7H25.647V22.6H22.0241V12.1907L17.1098 22.6H13.3791L8.60191 12.1907V22.6H5V7H9.89522L15.3093 18.8844Z"
        fill="black"
      />
    </svg>
  ),
};
